<template>
  <div class="inputField" :class="{inputInvalid: checkValidity && !isValid}">
    <label class="textBold" :for="fieldId">
      {{ $t("bnpl:special_field.customer.first_name.label") }}
      <span v-if="required" class="bold" style="color: var(--systemError)">*</span>
    </label>
    <input
      v-model="firstName"
      :id="fieldId"
      class="textInput"
      type="text"
      autocomplete="given-name"
      @blur="blur"
    />
  </div>
</template>

<script setup>
import { useProfileStore } from "~~/stores/profile";

const props = defineProps({
  fieldId: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    required: true,
  },
  checkValidity: {
    type: Boolean,
    required: true,
  },
});

const firstName = ref("");

const profileStore = useProfileStore();

const isValid = computed(() => {
  if (!props.required) return true;
  if (firstName.value) return true;
  return false;
});

onBeforeMount(() => {
  firstName.value = profileStore.firstName;
});

const blur = () => {
  profileStore.customerUpdate({ firstName: firstName.value });
};
</script>

<style scoped lang="scss"></style>
